<template>
    <b-modal :title="Core.Definition.getDefinition('Nouveau paiement')" class="modal-danger" v-model="dataShow" :hide-footer="true" cancel-variant="light">
        <Payment
                ref="payment"
                v-model="value"
                :forceTotal="forceTotal"
                :userId="userId"
                @onTokenizationSuccess="onTokenizationSuccess"
                @onPaymentCompleted="onPaymentCompleted"></Payment>
    </b-modal>
</template>

<script>
    import Payment from './Payment'
    export default {
        name: 'ModalPayment',
        components: {
            Payment,
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        date: '',
                        method: Core.Value.selectValue(Core.Payment.methodCC, Core.Payment.methodOptions()),
                        status: null,
                        referenceNumber: '',
                        subTotal: 0,
                        total: 0,
                        totalTaxes: 0,
                        token : '',
                        id: ''
                    }
                }
            },
            forceTotal: {
                type: Boolean,
                default: true
            },
            userId: {
                type: Number | String,
                default: function () {
                    return ''
                }
            }
        },
        watch: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                   return this.dataShow
                }
            }
        },
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false,
                dataUserId: ''
            }
        },
        methods: {
            onPaymentCompleted(payment) {
                this.$emit('onPaymentCompleted', payment)
            },
            onTokenizationSuccess(payment) {
                this.$emit('onTokenizationSuccess', payment)
            }
        }
    }
</script>
